import type { EventStatus } from "@/types";

export const weekdayCN = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];

export function formatDateCN(dateStr: string): string {
  const parts = dateStr.split("-");
  if (parts.length !== 3) return dateStr;
  return `${parts[0]}年${Number(parts[1])}月${Number(parts[2])}日`;
}

export function formatDateShort(dateStr: string): string {
  const parts = dateStr.split("-");
  if (parts.length !== 3) return dateStr;
  return `${Number(parts[1])}月${Number(parts[2])}日`;
}

export function getWeekday(dateStr: string): string {
  const d = new Date(`${dateStr}T00:00:00`);
  if (Number.isNaN(d.getTime())) return "";
  return weekdayCN[d.getDay()];
}

export interface StatusMeta {
  label: string;
  className: string;
  dot: string;
}

export function getStatusMeta(status: EventStatus): StatusMeta {
  if (status === "live") {
    return { label: "进行中", className: "bg-primary-500 text-background-50", dot: "bg-background-50" };
  }
  if (status === "finished") {
    return { label: "已结束", className: "bg-secondary-100 text-secondary-900", dot: "bg-secondary-500" };
  }
  return { label: "未开始", className: "bg-accent-100 text-accent-900", dot: "bg-accent-500" };
}

export function todayString(): string {
  const d = new Date();
  const m = `${d.getMonth() + 1}`.padStart(2, "0");
  const day = `${d.getDate()}`.padStart(2, "0");
  return `${d.getFullYear()}-${m}-${day}`;
}

export async function shareContent(title: string, text: string, url: string): Promise<"shared" | "copied" | "failed"> {
  const nav = navigator as Navigator & { share?: (data: { title: string; text: string; url: string }) => Promise<void> };
  try {
    if (typeof nav.share === "function") {
      await nav.share({ title, text, url });
      return "shared";
    }
  } catch {
    // user cancelled or share failed, fall back to copy
  }
  try {
    await navigator.clipboard.writeText(url);
    return "copied";
  } catch {
    return "failed";
  }
}